/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCatalogForSupplier200ResponseCatalog } from './GetCatalogForSupplier200ResponseCatalog';
import {
    GetCatalogForSupplier200ResponseCatalogFromJSON,
    GetCatalogForSupplier200ResponseCatalogFromJSONTyped,
    GetCatalogForSupplier200ResponseCatalogToJSON,
} from './GetCatalogForSupplier200ResponseCatalog';
import type { CatalogItemResponseDto } from './CatalogItemResponseDto';
import {
    CatalogItemResponseDtoFromJSON,
    CatalogItemResponseDtoFromJSONTyped,
    CatalogItemResponseDtoToJSON,
} from './CatalogItemResponseDto';

/**
 * 
 * @export
 * @interface GetCatalogForSupplier200Response
 */
export interface GetCatalogForSupplier200Response {
    /**
     * 
     * @type {Array<CatalogItemResponseDto>}
     * @memberof GetCatalogForSupplier200Response
     */
    data?: Array<CatalogItemResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof GetCatalogForSupplier200Response
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCatalogForSupplier200Response
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCatalogForSupplier200Response
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCatalogForSupplier200Response
     */
    pageSize?: number;
    /**
     * 
     * @type {GetCatalogForSupplier200ResponseCatalog}
     * @memberof GetCatalogForSupplier200Response
     */
    catalog?: GetCatalogForSupplier200ResponseCatalog;
}

/**
 * Check if a given object implements the GetCatalogForSupplier200Response interface.
 */
export function instanceOfGetCatalogForSupplier200Response(value: object): value is GetCatalogForSupplier200Response {
    return true;
}

export function GetCatalogForSupplier200ResponseFromJSON(json: any): GetCatalogForSupplier200Response {
    return GetCatalogForSupplier200ResponseFromJSONTyped(json, false);
}

export function GetCatalogForSupplier200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCatalogForSupplier200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CatalogItemResponseDtoFromJSON)),
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'catalog': json['catalog'] == null ? undefined : GetCatalogForSupplier200ResponseCatalogFromJSON(json['catalog']),
    };
}

export function GetCatalogForSupplier200ResponseToJSON(value?: GetCatalogForSupplier200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CatalogItemResponseDtoToJSON)),
        'totalPages': value['totalPages'],
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'pageSize': value['pageSize'],
        'catalog': GetCatalogForSupplier200ResponseCatalogToJSON(value['catalog']),
    };
}

